

export const GROUPED_FEED_TYPE = 'Each product group will have its own section in the feed widget. '
  + 'Show the widget preview to see how your feed will look.';

export const FLAT_FEED_TYPE = 'Your products will be displayed in a single flat list. '
  + 'Show the widget preview to see how your feed will look.';
